// Lista de marcas de veículos (carros e motos) mais comuns no mercado brasileiro
export const VEHICLE_BRANDS = [
  // Carros
  'Audi',
  'BMW',
  'BYD',
  'Caoa Chery',
  'Chevrolet',
  'Citroën',
  'Fiat',
  'Ford',
  'Honda',
  'Hyundai',
  'Jeep',
  'Kia',
  'Land Rover',
  'Mercedes-Benz',
  'Mitsubishi',
  'Nissan',
  'Peugeot',
  'Renault',
  'Toyota',
  'Volkswagen',
  'Volvo',
  
  // Motos
  'Aprilia',
  'Benelli',
  'Dafra',
  'Ducati',
  'Harley-Davidson',
  'Kawasaki',
  'Royal Enfield',
  'Shineray',
  'Suzuki',
  'Triumph',
  'Yamaha'
].sort();

export const VEHICLE_BRANDS_OPTIONS = [
  { value: '', label: 'Selecione uma marca' },
  ...VEHICLE_BRANDS.map(brand => ({ value: brand, label: brand }))
];

export const VEHICLE_BRANDS_FILTER_OPTIONS = [
  { value: '', label: 'Todas as Marcas' },
  ...VEHICLE_BRANDS.map(brand => ({ value: brand, label: brand }))
];
